"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var TripDatesComponent = (function () {
    function TripDatesComponent() {
        this.messages = this.buildMessages();
    }
    TripDatesComponent.prototype.ngOnChanges = function (changes) {
        if (changes['maxTripLength']) {
            this.messages = this.buildMessages();
        }
    };
    TripDatesComponent.prototype.buildMessages = function () {
        return {
            'departureDate': {
                'required': 'Departure Date is required.',
                'invalid': 'Departure Date must be a valid date in mm/dd/yyyy format.',
                'beforeToday': 'Departure Date must be a valid date in the future.'
            },
            'returnDate': {
                'required': 'Return Date is required.',
                'invalid': 'Return Date must be a valid date in mm/dd/yyyy format.',
                'beforeToday': 'Return Date must be a valid date in the future.',
                'beforeDeparture': 'Return Date must be on or after Departure Date.',
                'maxTripLength': "Trip can not exceed " + this.maxTripLength + " days."
            },
        };
    };
    return TripDatesComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormGroup)
], TripDatesComponent.prototype, "form", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], TripDatesComponent.prototype, "submitted", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], TripDatesComponent.prototype, "maxTripLength", void 0);
TripDatesComponent = __decorate([
    core_1.Component({
        selector: 'trip-dates',
        template: "<div class=\"row\" [formGroup]=\"form\">     <div class=\"form-group col-sm-6\">         <label>Departure Date</label>         <masked-datepicker placeholder=\"Departure Date\" formControlName=\"departureDate\"></masked-datepicker>         <validation-messages [control]=\"form.controls.departureDate\"                              [messages]=\"messages.departureDate\"                              [submitted]=\"submitted\"></validation-messages>     </div>     <div class=\"form-group col-sm-6\">         <label>Return Date</label>         <masked-datepicker placeholder=\"Return Date\" formControlName=\"returnDate\"></masked-datepicker>         <validation-messages [control]=\"form.controls.returnDate\"                              [messages]=\"messages.returnDate\"                              [submitted]=\"submitted\"></validation-messages>     </div> </div>"
    }),
    __metadata("design:paramtypes", [])
], TripDatesComponent);
exports.TripDatesComponent = TripDatesComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/trip-details/trip-dates.component.js